import type { CSSProperties } from 'react'
import { designTokens } from '@/shared/lib/design-tokens'
import { hexToHsl } from '@/shared/lib/catalog'

export const catalogThemeVars = {
  '--background': hexToHsl(designTokens.colors.background.page),
  '--foreground': hexToHsl(designTokens.colors.text.primary),
  '--card': hexToHsl(designTokens.colors.background.surface),
  '--card-foreground': hexToHsl(designTokens.colors.text.strong),
  '--popover': hexToHsl(designTokens.colors.background.surface),
  '--popover-foreground': hexToHsl(designTokens.colors.text.primary),
  '--primary': hexToHsl(designTokens.colors.brand.primary),
  '--primary-foreground': hexToHsl(designTokens.colors.text.inverse),
  '--secondary': hexToHsl(designTokens.colors.background.alt),
  '--secondary-foreground': hexToHsl(designTokens.colors.text.primary),
  '--muted': hexToHsl(designTokens.colors.background.alt),
  '--muted-foreground': hexToHsl(designTokens.colors.text.muted),
  '--accent': hexToHsl(designTokens.colors.background.alt),
  '--accent-foreground': hexToHsl(designTokens.colors.text.primary),
  '--destructive': hexToHsl(designTokens.colors.semantic.error),
  '--destructive-foreground': hexToHsl(designTokens.colors.text.inverse),
  '--border': hexToHsl(designTokens.colors.border.default),
  '--input': hexToHsl(designTokens.colors.border.default),
  '--ring': hexToHsl(designTokens.colors.brand.primary),
  '--radius': designTokens.borders.radius.lg,
  fontFamily: designTokens.typography.fontFamilies.primary,
  background: `linear-gradient(180deg, ${designTokens.colors.background.page} 0%, ${designTokens.colors.background.alt} 100%)`,
} as CSSProperties
